"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createC2DMessage = exports.createD2CMessage = exports.NAMESPACE = void 0;
const PrefsCommon = __importStar(require("../common/prefs"));
const message_1 = require("./message");
exports.NAMESPACE = 'Culligan.Protocol.V3.Prefs';
const createD2CMessage = (namespace, Prefs) => (0, message_1.createMessage)('prefs', PrefsCommon.createD2CMessage(namespace, Prefs)).annotations({
    identifier: `${namespace}.PrefsD2CMessage`,
    title: 'Prefs Message',
    description: 'A Device-To-Cloud message on the "prefs" channel',
});
exports.createD2CMessage = createD2CMessage;
const createC2DMessage = (namespace, Prefs) => (0, message_1.createMessage)('prefs', PrefsCommon.createC2DMessage(namespace, Prefs)).annotations({
    identifier: `${namespace}.PrefsC2DMessage`,
    title: 'Prefs Message',
    description: 'A Cloud-To-Device message on the "prefs" channel',
});
exports.createC2DMessage = createC2DMessage;
//# sourceMappingURL=prefs.js.map